import { render, staticRenderFns } from "./FaqListagem.vue?vue&type=template&id=2796e2fd&scoped=true"
import script from "./FaqListagem.vue?vue&type=script&lang=js"
export * from "./FaqListagem.vue?vue&type=script&lang=js"
import style0 from "./FaqListagem.vue?vue&type=style&index=0&id=2796e2fd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2796e2fd",
  null
  
)

export default component.exports